import { FC, useEffect, useState } from 'react';
import { useAgeGateIsVisible } from '@edikk-edikk/country-frontend';
import loadable from '@loadable/component';
import { useBaseContext } from '#base/hooks';

const AgeGate = loadable(() => import('#baseAgeGate/containers'), {
  resolveComponent: ({ AgeGate: Component }) => Component,
});

const AgeGateWrapper: FC = () => {
  const { ageGate } = useBaseContext();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isVisible = useAgeGateIsVisible(ageGate);

  useEffect(() => {
    if (isLoaded || !isVisible) {
      return;
    }

    AgeGate.load().then(() => {
      setIsLoaded(true);
    });
  }, [isLoaded, isVisible]);

  if (!isLoaded) {
    return null;
  }

  return <AgeGate />;
};

export { AgeGateWrapper };
